'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react.production.min.js');
} else {
  module.exports = require('./cjs/react.development.js');
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/xe-ui-kit/~/react/index.js
 ** module id = 2022
 ** module chunks = 73
 **/